import React from "react"
import {
  Navigation,
  Page,
  TaskTabPanel,
  Storage,
} from "interactive"
import Video from '../../components/Video'
import useStateCallback from "../../components/useStateCallback"

import editing_interactive from "../../images/editing/editing.png"
import version1 from "../../images/editing/Film_Editing_p2a.mp4"
import version1_captions from "file-loader!../../images/editing/Film_Editing_p2a.vtt"
import version2 from "../../images/editing/Film_Editing_p2b.mp4"
import version2_captions from "file-loader!../../images/editing/Film_Editing_p2b.vtt"
import TaskExternal from "interactive/dist/TaskExternal"

export const frontmatter = {
  title: "Editing",
  id: "id",
  figure: "1.1",
  path: "editing/",
}



function Editing() {
  let [viewed, setViewed] = useStateCallback(0)
  let v1 = React.useRef()
  let v2 = React.useRef()
  return <Navigation ghostMode>
    <Page>
      <h2>Editing</h2>
      <p>
        The order in which shots are arranged can change the way that we interpret narrative.
      </p>
      <img
        src={editing_interactive}
        style={{ width: "100%" }}
        alt={`An illustration of two film reels with three frames each. The film reel at the top is labeled "Version One." Its three frames are labeled as follows: Shot A, Shot B, Shot C. The second film reel is labeled "Version Two." Its three frames are labeled as follows: Shot C, Shot A, Shot B.`}
      />
      <p>
        To create the following interactive, for example, an editor arranged the same three shots into two short sequences. Only the order is different.
      </p>
    </Page>
    <Page>
      <p>
        To demonstrate how editing order affects our experience of a story, these 
        two short videos put their own spin on the same three shots featuring an 
        instructor and his class.
        <br />
        <br />
        Select each tab below and play the corresponding video to complete the 
        interactive.
      </p>
      <TaskTabPanel
        key="MV1"
        state={Storage()}
        onTabChange={(k)=>{
          [v1, v2].forEach((v, j) => {
            if (`${k}` === `${j}`) {
              v.current && v.current.show()
            } else {
              v.current && v.current.hide()
            }
          })
          v1.current && v1.current.pause()
          v2.current && v2.current.pause()
        }}
        contents={[
          {
            title: "Version 1",
            contents: (
              <React.Fragment>
                <Video
                  // slug="/wwnorton.college.protected.editorial/film/lookmov/interactives/edit-order-version-1"
                  mp4={version1}
                  vtt={version1_captions}
                  onPlay={()=>setViewed(viewed => viewed | 1)}
                  ref={v1}
                />
                <p>
                  <br />
                  In this sequence, our experience of events is restricted to the instructor’s 
                  point of view. We discover the misbehaving students at the same time as 
                  the character and, thus, share in his surprise.
                </p>
              </React.Fragment>
            ),
          },
          {
            title: "Version 2",
            contents: (
              <React.Fragment>
                <Video
                  // slug="/wwnorton.college.protected.editorial/film/lookmov/interactives/edit-order-version-2"
                  mp4={version2}
                  vtt={version2_captions}
                  onPlay={()=>setViewed(viewed => viewed | 2)}
                  ref={v2}
                />
                <p>
                  <br />
                  An omniscient camera narrator opens this version by sharing information 
                  not available to the instructor character. As we watch him approach, we 
                  anticipate the instructor’s reaction and form expectations about what will 
                  happen next.
                </p>
              </React.Fragment>
            ),
          },
        ]}
      />
      <TaskExternal
        state={Storage()}
        completed={viewed === 3}
      />
    </Page>
  </Navigation>
}

export default Editing
